import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MultiSelectStaticFilterChecks from './MultiSelectStaticFilterChecks';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

// TODO Update `Filters.jsx` so it is more configurable instead of using this component
export default class MultiSelectStaticFilterDropdown extends Component {
  static propTypes = {
    triggerClassName: PropTypes.string,
    currentItemText: PropTypes.string,
    listClassName: PropTypes.string,
    collections: PropTypes.object,
  }

  static defaultProps = {
    triggerClassName: '',
    currentItemText: '',
    listClassName: 'List List--multiple',
  }

  render() {
    const filters = Object.keys(this.props.collections).map((filter) =>
      <MultiSelectStaticFilterChecks key={filter} id={filter} {...this.props.collections[filter]} />
    );

    return (
      <Dropdown className="u-relative u-w-full">
        <DropdownTrigger>
          <div className={`u-mr-5 u-relative ${this.props.triggerClassName}`}>
            { this.props.currentItemText }
          </div>
        </DropdownTrigger>

        <DropdownContent
          className="dropdown-content u-overflow-visible u-w-64">
          <div>
            <ul className={this.props.listClassName}>
              {filters}
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>

    );
  }
}
